"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StyledResponsiveDialog = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const StyledResponsiveDialog = exports.StyledResponsiveDialog = (0, _mui.styled)(_presentationComponents.ResponsiveDialog)((param)=>{
    let { theme } = param;
    return {
        [".".concat(_presentationComponents.responsiveDialogClasses.footer)]: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(3)
        },
        [".".concat(_presentationComponents.responsiveDialogClasses.dialogContent)]: {
            margin: theme.spacing(0, 1)
        },
        [".".concat(_presentationComponents.responsiveDialogClasses.drawerFooter)]: {
            padding: theme.spacing(4)
        }
    };
});
